import React from "react";
import { View, Text, TextInput, Button, Icon } from "ui";
import { User } from "types";
import { RouteComponentProps } from "react-router-dom";
import { userMutations } from "api";
import { notify } from "../shared/services/notify";
import { theme, styled } from "styles";

interface P {
  currentUser: User;
}

export default class BillingInfo extends React.Component<
  P & RouteComponentProps
> {
  public state = {
    name: this.props.currentUser.name || "",
    userType: this.props.currentUser.type || "individual",
    address: this.props.currentUser.address || "",
    uniqueId: this.props.currentUser.unique_identifier || ""
  };

  public fChecked = "black";
  public jChecked = "black";

  public handleCheckF = () => {
    this.setState({ userType: "individual", name: '', address: '', uniqueId: '', });
  }
  public handleCheckJ = () => {
    this.setState({ userType: "company", name: '', address: '', uniqueId: '' });
  }

  public render = () => {
    const isIndividual = this.state.userType === "individual";
    const {  name, userType, address, uniqueId } = this.state;
    return (
      <View flexDirection="column">
        <View mb={2}>
          <Text fontSize={5} fontWeight="bold">
            Date de Facturare
          </Text>
        </View>
        <userMutations.EditUser>
          {editUser => (
            <form
              onSubmit={async e => {
                e.preventDefault();
                try {
                  const name = this.state.name;
                  const type = this.state.userType;
                  const address = this.state.address;
                  const uniqueId = this.state.uniqueId;

                  await editUser({
                    variables: { type, name, address, uniqueId }
                  });
                  this.props.history.replace("/app/cumpara/plata");
                } catch (err) {}
              }}
            >
              <View flexDirection="column">
                <View pl={1} flexDirection="column" alignItems="flex-start">
                  <Button
                    bg="white"
                    mb={2}
                    flexDirection="row"
                    color="black"
                    onClick={this.handleCheckF}
                  >
                    <Icon
                      name={isIndividual ? "radiobox-marked" : "radiobox-blank"}
                      color={
                        isIndividual ? theme.colors.primary : theme.colors.black
                      }
                      size={1.5}
                    />
                    <Text fontWeight="bold" ml={1} fontSize={4}>
                      Persoana Fizica
                    </Text>
                  </Button>

                  <Button
                    bg="white"
                    mb={2}
                    flexDirection="row"
                    color="black"
                    onClick={this.handleCheckJ}
                  >
                    <Icon
                      name={!isIndividual ? "radiobox-marked" : "radiobox-blank"}
                      color={
                        isIndividual ? theme.colors.black : theme.colors.primary
                      }
                      size={1.5}
                    />
                    <Text fontWeight="bold" ml={1} fontSize={4}>
                      Persoana Juridica
                    </Text>
                  </Button>
                </View>
                <Text mb={2} mt={1} fontSize={2} fontWeight="bold">Aceste date vor fi folosire pentru emiterea facturii.</Text>
                <Input
                  mt={1}
                  mb={1}
                  placeholder="Nume Client"
                  value={name}
                  onChange={e => this.setState({ name: e.target.value })}
                />

                {this.state.userType !== 'individual' &&  <Input
                  mt={1}
                  mb={1}
                  placeholder="CUI"
                  value={uniqueId}
                  onChange={e => this.setState({ uniqueId: e.target.value })}
                />}
                <Input
                  mt={1}
                  mb={1}
                  placeholder="Strada/Oras/Judet"
                  value={address}
                  onChange={e => this.setState({ address: e.target.value })}
                />
                <Button
                  as="button"
                  type="submit"
                  border="none"
                  to={`/app/cumpara/plata`}
                >
                  <Text color="white" fontSize={5}>
                    Plateste
                  </Text>
                </Button>
              </View>
            </form>
          )}
        </userMutations.EditUser>
      </View>
    );
  }
}

const Input = styled(TextInput)`
  height: 40px;
`;



// WEBPACK FOOTER //
// ./src/pages/BillingInfo.tsx